/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { ConfirmPackageImageRequestToJSON, PackageImageDTOFromJSON, PaginatedResponseWarehousePackageListItemDTOFromJSON, PresignPackageImageRequestToJSON, PresignPackageImageResponseFromJSON, UpdateWarehousePackageCostRequestToJSON, UpdateWarehousePackageStatusRequestToJSON, WarehousePackageDetailDTOFromJSON, WarehousePackageListItemDTOFromJSON, WarehousePackageSummaryDTOFromJSON, } from '../models/index';
/**
 *
 */
export class WarehouseControllerApi extends runtime.BaseAPI {
    /**
     */
    async confirmImageRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling confirmImage().');
        }
        if (requestParameters['confirmPackageImageRequest'] == null) {
            throw new runtime.RequiredError('confirmPackageImageRequest', 'Required parameter "confirmPackageImageRequest" was null or undefined when calling confirmImage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages/{id}/images/confirm`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmPackageImageRequestToJSON(requestParameters['confirmPackageImageRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PackageImageDTOFromJSON(jsonValue));
    }
    /**
     */
    async confirmImage(requestParameters, initOverrides) {
        const response = await this.confirmImageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteImageRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteImage().');
        }
        if (requestParameters['imageId'] == null) {
            throw new runtime.RequiredError('imageId', 'Required parameter "imageId" was null or undefined when calling deleteImage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages/{id}/images/{imageId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"imageId"}}`, encodeURIComponent(String(requestParameters['imageId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteImage(requestParameters, initOverrides) {
        await this.deleteImageRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getPackageRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getPackage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehousePackageDetailDTOFromJSON(jsonValue));
    }
    /**
     */
    async getPackage(requestParameters, initOverrides) {
        const response = await this.getPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getSummaryRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/summary`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehousePackageSummaryDTOFromJSON(jsonValue));
    }
    /**
     */
    async getSummary(initOverrides) {
        const response = await this.getSummaryRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listPackagesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['packageStatus'] != null) {
            queryParameters['packageStatus'] = requestParameters['packageStatus'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseWarehousePackageListItemDTOFromJSON(jsonValue));
    }
    /**
     */
    async listPackages(requestParameters = {}, initOverrides) {
        const response = await this.listPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async presignImageRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling presignImage().');
        }
        if (requestParameters['presignPackageImageRequest'] == null) {
            throw new runtime.RequiredError('presignPackageImageRequest', 'Required parameter "presignPackageImageRequest" was null or undefined when calling presignImage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages/{id}/images/presign`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PresignPackageImageRequestToJSON(requestParameters['presignPackageImageRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PresignPackageImageResponseFromJSON(jsonValue));
    }
    /**
     */
    async presignImage(requestParameters, initOverrides) {
        const response = await this.presignImageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateCostRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateCost().');
        }
        if (requestParameters['updateWarehousePackageCostRequest'] == null) {
            throw new runtime.RequiredError('updateWarehousePackageCostRequest', 'Required parameter "updateWarehousePackageCostRequest" was null or undefined when calling updateCost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages/{id}/cost`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWarehousePackageCostRequestToJSON(requestParameters['updateWarehousePackageCostRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehousePackageListItemDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateCost(requestParameters, initOverrides) {
        const response = await this.updateCostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateStatusRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateStatus().');
        }
        if (requestParameters['updateWarehousePackageStatusRequest'] == null) {
            throw new runtime.RequiredError('updateWarehousePackageStatusRequest', 'Required parameter "updateWarehousePackageStatusRequest" was null or undefined when calling updateStatus().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse/packages/{id}/status`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWarehousePackageStatusRequestToJSON(requestParameters['updateWarehousePackageStatusRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehousePackageListItemDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateStatus(requestParameters, initOverrides) {
        const response = await this.updateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ListPackagesPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
